import * as React from 'react'
import { observer } from 'mobx-react'
import NotificationsSidebarViewModel from '../NotificationsSidebarViewModel'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import WorkspaceSelectorViewHeading from 'components/WorkspaceSelectorViewHeading'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'

interface NotificationsSidebarHeaderProps {
  vm: NotificationsSidebarViewModel
  scrollOffset: ScrollOffsetInterpolation
}

export default observer(function NotificationsSidebarHeader({
  vm,
  scrollOffset,
}: NotificationsSidebarHeaderProps) {
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>
        <WorkspaceSelectorViewHeading
          value={vm.selectedWorkspace}
          onChange={vm.selectWorkspace}
          primaryText="Notifications"
          allOptionText="All Workspaces"
          workspaces={vm.workspaces}
          dropdownTitle="View notifications for"
        />
      </StickyViewHeaderMain>
    </StickyViewHeader>
  )
})
